export default {
  assetNotSupported: '{assetDisplayName} is either not assigned to a data source or does not have its own view in Remote Control.',
};
